import type {ReactNode} from 'react'
import {CopilotChatProvider} from '@github-ui/copilot-chat/CopilotChatContext'
import type {CopilotChatOrg, CopilotChatReference} from '@github-ui/copilot-chat-types'
import type {ChatPayload} from './copilot-chat-payload-route-query'

const EMPTY_REFS: CopilotChatReference[] = []
const EMPTY_SSO_ORGANIZATIONS: CopilotChatOrg[] = []

export interface CopilotChatProvidersProps {
  children: ReactNode
  chatPayload: ChatPayload
  waitForInitialInstructionRules?: boolean
  instructionRulesLoadingFallback?: ReactNode
}

export function CopilotChatProviders({
  children,
  chatPayload,
  waitForInitialInstructionRules,
  instructionRulesLoadingFallback,
}: CopilotChatProvidersProps) {
  return (
    <CopilotChatProvider
      threadId={null}
      refs={chatPayload.refs ?? EMPTY_REFS}
      mode="assistive"
      ssoOrganizations={chatPayload.ssoOrganizations ?? EMPTY_SSO_ORGANIZATIONS}
      copilotChatPayload={chatPayload}
      waitForInitialInstructionRules={waitForInitialInstructionRules}
      instructionRulesLoadingFallback={instructionRulesLoadingFallback}
    >
      {children}
    </CopilotChatProvider>
  )
}
